<template>
  <div class="builds-module-root">
    <ba-header activeModule="Current Builds" disable-menu="true"></ba-header>
    <div class="u-p4 main-content" v-loading="loading">

      <h2 class="u-mt2 c-heading__page">Current Builds</h2>

      <el-button @click="showBulkBuild = !showBulkBuild"
               :icon="showBulkBuild? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
               :type="showBulkBuild? 'danger' : 'primary'">
        Bulk Builds Control</el-button>

      <el-collapse-transition>
        <div v-show="showBulkBuild">
            <div class="transition-box el-card">
                <ba-new-build-component v-if="showBulkBuild" @gitLoading="gitLoading"></ba-new-build-component>
                <div v-loading="gitLoadingStatus.loading">
                  <el-button :disabled="!selectedItems.length" @click="launchWebBuilds">Launch Web Builds</el-button>
                  <el-button :disabled="!selectedItems.length" @click="launchMobileBuilds">Launch Mobile Builds</el-button>
                </div>

            </div>
        </div>
      </el-collapse-transition>

      <el-table class="u-mt4" v-loading="loading" v-if="builds && builds.length > 0" :data="builds"
                @selection-change="onSelectionChange">
          <el-table-column v-if="showBulkBuild" type="selection" width="50"></el-table-column>
          <el-table-column
                  prop="company"
                  label="Company"
                  sortable>
          </el-table-column>
          <el-table-column
                  prop="mobile_build.build_number"
                  label="Mobile Version">
          </el-table-column>
          <el-table-column
                  label="Mobile Build Dt"
                  sortable>
              <template slot-scope="scope">
                {{ fixedTimestamp(scope.row.mobile_build) }}
              </template>                  
          </el-table-column>
          <el-table-column
              prop="desktop_build.build_number"
              label="Desktop Version">
          </el-table-column>
          <el-table-column
                  label="Desktop Build Dt"
                  sortable>
              <template slot-scope="scope">
                {{ fixedTimestamp(scope.row.desktop_build) }}
              </template>                   
          </el-table-column>
          <el-table-column
              prop="desktop_build.deployed_status"
              label="Desktop Deployed Status">
          </el-table-column>
          <el-table-column
                  label="BC status">
              <template slot-scope="scope">
                <ba-healthcheck-status :healthcheck="healthcheckByCompany(scope.row.company_id)"/>
              </template>
          </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import config from '@/config'
  import * as moment from 'moment'
  import {mapGetters, mapActions} from 'vuex'
  import BaNewBuild from '@/components/new.build.component'
  import BaHealthCheck from '@/components/healthcheck-status.component'

  export default {

    name: 'baCurrentBuildsList',
    components: {
      'ba-new-build-component': BaNewBuild,
      'ba-healthcheck-status': BaHealthCheck
    },
    data () {
      return {
        builds: null,
        loading: true,
        showBulkBuild: false,
        gitLoadingStatus: {loading: true},
        selectedItems: []
      }
    },
    computed: {
      ...mapGetters('shared', ['healthcheckByCompany']),
      selectedCompaniesIds () {
        return this.selectedItems.map(item => item.company_id)
      }
    },
    methods: {
      ...mapActions('shared', ['loadHealthcheck']),
      onSelectionChange (selectedItems) {
        this.selectedItems = selectedItems
      },
      gitLoading (value) {
        this.gitLoadingStatus = value
      },
      loadBuilds () {
        let url = config.url + `/current-builds/`
        this.loading = true

        axios.get(url)
          .then(response => {
            this.builds = response.data
            this.loading = false
          })
          .catch(e => {
            this.loading = false
            this.$notify.error({
              title: 'Error',
              message: 'Failed to load current builds',
            })
            this.builds = null
          })
      },
      fixedTimestamp (buildInfo) {
        let timestamp = buildInfo.completed_at ? buildInfo.completed_at : buildInfo.queued_at
        if (!timestamp) {
          return ''
        }
        return moment(new Date(timestamp)).format('MM/DD/YYYY hh:mm:ss A')
      },

      launchSingleBuild (companyId, mode) {
        let data = {
          commit_id: this.gitLoadingStatus.commitId,
          build_comment: this.gitLoadingStatus.buildComment,
          publish_to_test_flight: false,
          run_smoke_tests_when_completed: false,
          deploy_when_completed: mode === 'desktop'
        }
        return axios.post(`${config.url}/company/${companyId}/build-${mode}-app/`, data)
      },
      launchBuilds (mode) {
        return this.selectedCompaniesIds.map(id => this.launchSingleBuild(id, mode))
      },
      async launchBuildsAndNotify (mode) {
        let promises = this.launchBuilds(mode)
        console.log(promises)
        try {
          await Promise.all(promises)
          this.$notify({
            title: 'Success',
            message: 'Builds have been queued...',
            type: 'success'
          })
        } catch (error) {
          console.log(error)
          this.$notify.error({
            title: 'Error',
            message: 'Failed to queue some builds',
          })
        }
      },
      async launchMobileBuilds () {
        this.loading = true
        await this.launchBuildsAndNotify('mobile')
        this.loading = false
      },
      async launchWebBuilds () {
        this.loading = true
        await this.launchBuildsAndNotify('desktop')
        this.loading = false
      },
    },
    beforeMount () {
      this.loadBuilds()
      this.loadHealthcheck()
    },
  }
</script>
